import * as React from "react";
import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../ui/select/SelectComponent";
import JobStatus from "../../../model/job/JobStatus";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import JobStatusCategory, {JobStatusCategoryEnum} from "../../../model/job/JobStatusCategory";
import JobStatusExternalCategory from "../../../model/job/JobStatusExternalCategory";
import '../../../../resources/scss/component/jobStatus/jobStatusSelector.scss';
import classNames = require("classnames");

interface Props {
	isJobInvoiceOrBillPaid?: boolean
}

class SelectJobStatus extends SelectComponent<JobStatus, Props> {

	matchFilter(element: JobStatus, filter: string): boolean {
		return element.getStatusLabel().toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
			element.externalLabel.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: JobStatus): string {
		return element.id;
	}

	elementToString(element: JobStatus): string {
		return element.getStatusLabel(true);
	}

	getDropdownList(): Option<JobStatus[]> {
		return this.props.items.map(list => list.filter(
			u => !u.disabled && (this.props.isJobInvoiceOrBillPaid ? u.category != JobStatusCategoryEnum.Cancelled : true)));
	}

	renderOption(props: { data: JobStatus, isSelected: boolean, isFocused: boolean, innerProps: any, innerRef: any }) {
		const classFromProps = classNames({
			"c-select-component__option": true,
			"c-select-component__option--is-selected": props.isSelected,
			"c-select-component__option--is-focused": props.isFocused,
		});

		return (
			<div ref={props.innerRef} {...props.innerProps} className={classFromProps}>
				{this.getText(props.data)}
			</div>
		)
	}

	renderValue(props: { data: JobStatus, isFocused: boolean, innerProps: any, innerRef: any }) {
		const classFromProps = classNames({
			"c-select-component__control": true,
			"c-job-status-select__option": true,
			"c-select-component__control--is-focused": props.isFocused,
		});
		return (
			<div ref={props.innerRef} {...props.innerProps} className={classFromProps}>
				{this.getText(props.data)}
			</div>
		);
	}

	getText(jobStatus: JobStatus) {
		return (
			<>
				<div className="options-wrapper">
					<div className="first-row">
						<div className="with-label category">
							<span>{JobStatusCategory.createCategory(jobStatus.category).label}</span>
							<span className="label">Internal</span>
						</div>
						<span className="status">{this.elementToString(jobStatus)}</span>
					</div>
					<div className="second-row">
						<div className="with-label category">
							{JobStatusExternalCategory.createExternalCategory(jobStatus.externalCategory).label}
							<span className="label">External</span>
						</div>
						<span className="status">{jobStatus.externalLabel}</span>
					</div>
				</div>
			</>
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.jobStatus.jobStatuses
	}
}

export default connect<SelectComponentReduxProps<JobStatus>, SelectComponentComponentProps<JobStatus>, Props>(mapStateToProps)(
	SelectJobStatus)
